/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const TriangleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
    >
      <path
        d="M19.8661 16.0806L10.8697 0.506747C10.7825 0.35291 10.656 0.224953 10.5033 0.135929C10.3505 0.0469046 10.1768 0 10 0C9.82318 0 9.64952 0.0469046 9.49674 0.135929C9.34396 0.224953 9.21753 0.35291 9.13035 0.506747L0.133921 16.0806C0.046188 16.2325 0 16.4049 0 16.5804C0 16.7558 0.046188 16.9282 0.133921 17.0802C0.221991 17.2327 0.348804 17.3593 0.501521 17.447C0.654238 17.5348 0.827436 17.5807 1.00358 17.58H18.9964C19.1726 17.5807 19.3458 17.5348 19.4985 17.447C19.6512 17.3593 19.778 17.2327 19.8661 17.0802C19.9538 16.9282 20 16.7558 20 16.5804C20 16.4049 19.9538 16.2325 19.8661 16.0806ZM2.73289 15.5808L10 3.00575L17.2671 15.5808H2.73289Z"
        fill="black"
      />
    </svg>
  )
}
